import React from "react";
import { useNexOs } from "@/lib/nexOs";
import { useLabel } from "@/lib/dynamicEngine";

/**
 * Tier 0 — Master Vertical Selector.
 * 3 pill tabs; switching re-skins the data context without remounting layout.
 */
export default function VerticalSelector() {
  const { schema, vertical, setVertical } = useNexOs();
  const kicker = useLabel("nds.selector.kicker", "// SELECT INDUSTRY VERTICAL");
  const items = schema?.verticals || [];

  return (
    <section
      data-testid="nds-vertical-selector"
      className="w-full border-b border-white/8"
    >
      <div className="w-full max-w-[1920px] mx-auto px-6 lg:px-10 py-5 flex flex-col gap-3">
        <div className="nds-label-dim">{kicker}</div>
        <div className="flex flex-wrap gap-3">
          {items.map((v) => {
            const active = v.id === vertical;
            return (
              <button
                key={v.id}
                type="button"
                data-testid={`nds-vertical-tab-${v.id}`}
                data-active={active}
                onClick={() => setVertical(v.id)}
                className={`nds-tab ${active ? "nds-tab--active" : ""}`}
              >
                {v.label}
              </button>
            );
          })}
          {items.length === 0 && (
            <div className="nds-label-dim" data-testid="nds-vertical-empty">Loading verticals…</div>
          )}
        </div>
        {items.length > 0 && (
          <p
            className="font-mono text-[0.75rem] text-nex-chrome tracking-[0.04em]"
            data-testid="nds-vertical-tagline"
          >
            {(items.find((v) => v.id === vertical) || items[0])?.tagline}
          </p>
        )}
      </div>
    </section>
  );
}
